import { usePersist } from "../../lib/usePersist";
import { useState } from "react";
import { ChevronRight } from "lucide-react";

const ORDER = ["mini-break", "premium", "ultra", "elite"];
const LABEL = { "mini-break": "Mini-Break", premium: "Premium", ultra: "Ultra", elite: "Elite", standalone: "Standalone", guide: "One-off guides" };
const tierOf = (k) => (k.topic_kit ? `topic-${k.topic_kit.key}` : k.tier || "other");
const rank = (t) => (t.startsWith("topic-") ? 50 : ORDER.indexOf(t) + 1 || 99);

export const byTier = (kits) => {
  const map = {};
  const names = {};
  kits.forEach((k) => { const t = tierOf(k); (map[t] = map[t] || []).push(k); if (k.topic_kit) names[t] = `${k.topic_kit.label} kits`; });
  return Object.keys(map).sort((a, b) => rank(a) - rank(b) || a.localeCompare(b)).map((t) => ({ tier: t, kits: map[t], label: names[t] }));
};

export const TierGroup = ({ gid, tier, kits, render, label }) => {
  const [open, setOpen] = usePersist(`tier-${gid}-${tier}`, true);
  const live = kits.filter((k) => k.product?.published).length;
  return (
    <div data-testid={`tier-group-${gid}-${tier}`} className="border-t border-stone-100">
      <button data-testid={`tier-toggle-${gid}-${tier}`} onClick={() => setOpen(!open)} aria-expanded={open}
        className="w-full flex items-center gap-2 px-5 py-2.5 text-left hover:bg-stone-50 transition-colors">
        <ChevronRight size={15} className={`text-stone-500 transition-transform duration-200 ${open ? "rotate-90" : ""}`} />
        <span className="text-sm font-semibold text-[#2B2A26]">{label || LABEL[tier] || tier}</span>
        <span data-testid={`tier-count-${gid}-${tier}`} className="text-xs font-mono-ui text-stone-500">{kits.length} · {live} live</span>
      </button>
      {open && <ul data-testid={`tier-list-${gid}-${tier}`}>{kits.map(render)}</ul>}
    </div>
  );
};
